import { CustomFormFieldFG, FormFieldFG, FormFieldTypeFG, SelectFormFieldFG } from '@hwm/ui-lib';
import { t, Trans } from '@lingui/macro';
import { Typography } from '@material-ui/core';
import { AlarmsAcknowledgeOptionsFn } from '@shared/components/Filters';
import { AlarmsAcknowledgeType, BaseExportType, TimeRangeOptionsFn } from '@shared/models';

export const generalPreferencesFieldsConfiguration = (
  conditions: string[],
  exports: BaseExportType[]
): FormFieldFG[] => {
  return [
    {
      label: '',
      property: 'timeRangeTitle',
      type: FormFieldTypeFG.CustomField,
      renderer: () => {
        return (
          <Typography>
            <Trans>Time Range</Trans>
          </Typography>
        );
      },
    } as CustomFormFieldFG,
    {
      label: '',
      property: 'timeRange',
      type: FormFieldTypeFG.Select,
      availableValues: Object.entries(TimeRangeOptionsFn()).map(([value, { label }]) => ({
        label,
        value,
      })),
      returnKeyOnly: true,
      innerSelectLabel: t`Range`,
      containerClasses: 'mb-6',
    } as SelectFormFieldFG,
    {
      label: '',
      property: 'alarmTitle',
      type: FormFieldTypeFG.CustomField,
      renderer: () => {
        return (
          <Typography>
            <Trans>Alarms</Trans>
          </Typography>
        );
      },
    } as CustomFormFieldFG,
    {
      label: '',
      property: 'alarmCondition',
      type: FormFieldTypeFG.Select,
      availableValues: conditions.map((condition) => ({
        label: condition,
        value: condition,
      })),
      returnKeyOnly: true,
      innerSelectLabel: t`Condition`,
      containerClasses: 'mb-4',
    } as SelectFormFieldFG,
    {
      label: '',
      property: 'alarmAcknowledge',
      type: FormFieldTypeFG.Select,
      availableValues: Object.values(AlarmsAcknowledgeType).map((value) => ({
        label: AlarmsAcknowledgeOptionsFn()[value],
        value,
      })),
      returnKeyOnly: true,
      innerSelectLabel: t`Acknowledge`,
      containerClasses: 'mb-3',
    } as SelectFormFieldFG,
    {
      label: t`System Alarms`,
      property: 'alarmShowSystem',
      type: FormFieldTypeFG.Checkbox,
      containerClasses: 'mb-6',
    },
    {
      label: '',
      property: 'exportTitle',
      type: FormFieldTypeFG.CustomField,
      renderer: () => {
        return (
          <Typography>
            <Trans>Exports</Trans>
          </Typography>
        );
      },
    } as CustomFormFieldFG,
    {
      label: '',
      property: 'exportFormat',
      type: FormFieldTypeFG.Select,
      availableValues: exports.map((value) => ({
        label: value,
        value,
      })),
      returnKeyOnly: true,
      innerSelectLabel: t`Export`,
      containerClasses: 'mb-6',
    } as SelectFormFieldFG,
  ];
};
